(() => {
  if (window.ksQuickShopLoaded) return;
  window.ksQuickShopLoaded = true;

  const quickShop = document.querySelector('[data-ks-quick-shop]');
  const quickContent = quickShop?.querySelector('[data-ks-quick-shop-content]');
  const sizeDrawer = document.querySelector('[data-ks-size-drawer]');
  const sizeContent = sizeDrawer?.querySelector('[data-ks-size-content]');
  let quickRequest;
  let sizeGuideLoaded = false;

  const closeDialog = dialog => {
    if (dialog?.open) dialog.close();
  };

  const productUrlFromCard = card => card?.querySelector('a[data-grid-link]')?.href;

  async function openQuickShop(url) {
    if (!quickShop || !quickContent || !url) return;
    quickRequest?.abort();
    quickRequest = new AbortController();
    quickContent.innerHTML = `<div class="ks-quick-shop__loading" role="status">${quickShop.dataset.loadingLabel || 'Loading'}</div>`;
    if (!quickShop.open) quickShop.showModal();
    try {
      const target = new URL(url, window.location.origin);
      target.searchParams.set('section_id', 'api-ks-quick-shop');
      const response = await fetch(target, { signal: quickRequest.signal, headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const apiContent = parsed.querySelector('[data-api-content]');
      if (!apiContent) throw new Error('Missing quick shop content');
      quickContent.replaceChildren(...apiContent.childNodes);
      quickContent.scrollTop = 0;
    } catch (error) {
      if (error.name === 'AbortError') return;
      window.location.assign(url);
    }
  }

  async function openSizeGuide() {
    if (!sizeDrawer || !sizeContent) return;
    if (!sizeDrawer.open) sizeDrawer.showModal();
    if (sizeGuideLoaded) return;
    sizeContent.innerHTML = `<div class="ks-quick-shop__loading" role="status">${quickShop?.dataset.loadingLabel || 'Loading'}</div>`;
    try {
      const response = await fetch(quickShop.dataset.sizeGuideUrl, { headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error(String(response.status));
      const html = await response.text();
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const guide = parsed.querySelector('.ks-size-guide');
      if (!guide) throw new Error('Missing size guide');
      sizeContent.replaceChildren(guide);
      sizeGuideLoaded = true;
    } catch (error) {
      window.location.assign(quickShop.dataset.sizeGuideUrl);
    }
  }

  document.addEventListener('click', event => {
    const closeQuick = event.target.closest('[data-ks-quick-shop-close]');
    if (closeQuick) {
      closeDialog(quickShop);
      return;
    }
    const closeSize = event.target.closest('[data-ks-size-close]');
    if (closeSize) {
      closeDialog(sizeDrawer);
      return;
    }
    const colorLink = event.target.closest('[data-ks-quick-shop-color]');
    if (colorLink) {
      event.preventDefault();
      openQuickShop(colorLink.href);
      return;
    }
    const sizeGuideLink = event.target.closest('[data-ks-size-guide-link]');
    if (sizeGuideLink) {
      event.preventDefault();
      openSizeGuide();
      return;
    }
    const sizeOption = event.target.closest('[data-ks-size-option]');
    if (sizeOption && !sizeOption.disabled) {
      const form = sizeOption.closest('[data-ks-quick-shop-form]');
      form.querySelectorAll('[data-ks-size-option]').forEach(button => {
        button.setAttribute('aria-checked', button === sizeOption ? 'true' : 'false');
      });
      form.querySelector('[data-ks-variant-id]').value = sizeOption.dataset.variantId;
      const submit = form.querySelector('[data-ks-quick-shop-submit]');
      submit.disabled = false;
      submit.querySelector('[data-ks-submit-label]').textContent = form.dataset.addLabel;
      return;
    }
    const guideTab = event.target.closest('.ks-size-drawer .ks-size-guide__tabs button');
    if (guideTab) {
      const guide = guideTab.closest('.ks-size-guide');
      const targetId = guideTab.getAttribute('aria-controls');
      guide.querySelectorAll('.ks-size-guide__tabs button').forEach(button => {
        const active = button === guideTab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      guide.querySelectorAll('.ks-size-guide__panel').forEach(panel => {
        panel.hidden = panel.id !== targetId;
      });
      return;
    }
    const card = event.target.closest('product-grid-item.ks-card');
    if (!card) return;
    const cardLink = event.target.closest('a[data-grid-link]');
    const quickButton = event.target.closest('.ks-card__atc');
    if (!cardLink && !quickButton) return;
    if (quickButton?.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    openQuickShop(cardLink?.href || productUrlFromCard(card));
  }, true);

  quickShop?.addEventListener('click', event => {
    if (event.target === quickShop) closeDialog(quickShop);
  });
  sizeDrawer?.addEventListener('click', event => {
    if (event.target === sizeDrawer) closeDialog(sizeDrawer);
  });

  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-ks-quick-shop-form]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[data-ks-quick-shop-submit]');
    const label = submit.querySelector('[data-ks-submit-label]');
    const errorNode = form.querySelector('[data-ks-quick-shop-error]');
    if (!form.querySelector('[data-ks-variant-id]').value) return;
    submit.disabled = true;
    label.textContent = form.dataset.addingLabel;
    errorNode.hidden = true;
    try {
      const response = await fetch(window.theme?.routes?.cart_add_url || `${window.Shopify.routes.root}cart/add`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || form.dataset.errorLabel);
      closeDialog(quickShop);
      document.dispatchEvent(new CustomEvent('theme:cart:reload', { bubbles: true }));
      const cartResponse = await fetch(`${window.theme.routes.cart}.js`);
      const cart = await cartResponse.json();
      document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart }, bubbles: true }));
      const drawerToggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
      if (drawerToggle && !window.theme?.state?.cartOpen) drawerToggle.click();
    } catch (error) {
      errorNode.textContent = error.message || form.dataset.errorLabel;
      errorNode.hidden = false;
      submit.disabled = false;
      label.textContent = form.dataset.addLabel;
    }
  });

  const money = cents => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: window.theme?.currencyCode || 'USD'
      }).format(cents / 100);
    } catch (error) {
      return `${(cents / 100).toFixed(2)} ${window.theme?.currencyCode || ''}`.trim();
    }
  };

  const escapeHtml = value => String(value ?? '')
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#039;');

  async function renderRecommendations(cart) {
    const holder = document.querySelector('[data-ks-cart-recommendations]');
    if (!holder || !cart?.items?.length) {
      if (holder) holder.hidden = true;
      return;
    }
    const productId = cart.items[0].product_id;
    const limit = Number(holder.dataset.limit || 6);
    try {
      const endpoint = `${window.theme.routes.product_recommendations_url}.json?product_id=${encodeURIComponent(productId)}&limit=${limit}&intent=complementary`;
      const response = await fetch(endpoint);
      const data = await response.json();
      const cartIds = new Set(cart.items.map(item => Number(item.product_id)));
      const products = (data.products || []).filter(product => !cartIds.has(Number(product.id))).slice(0, limit);
      if (!products.length) {
        holder.hidden = true;
        return;
      }
      const list = holder.querySelector('[data-ks-cart-recommendations-list]');
      list.innerHTML = products.map(product => {
        const featuredImage = product.featured_image || product.images?.[0] || '';
        const image = typeof featuredImage === 'string' ? featuredImage : featuredImage.url || featuredImage.src || '';
        const price = product.price || product.variants?.[0]?.price || 0;
        return `<a class="ks-cart-recommendation" href="${escapeHtml(product.url)}" data-ks-recommendation-link><img src="${escapeHtml(image)}" alt="" loading="lazy"><span class="ks-cart-recommendation__info"><span class="ks-cart-recommendation__title">${escapeHtml(product.title)}</span><span class="ks-cart-recommendation__price">${escapeHtml(money(Number(price)))}</span></span></a>`;
      }).join('');
      holder.hidden = false;
    } catch (error) {
      holder.hidden = true;
    }
  }

  document.addEventListener('click', event => {
    const link = event.target.closest('[data-ks-recommendation-link]');
    if (!link) return;
    event.preventDefault();
    const drawerToggle = document.querySelector('[data-drawer-toggle="drawer-cart"]');
    if (window.theme?.state?.cartOpen && drawerToggle) drawerToggle.click();
    openQuickShop(link.href);
  });
  document.addEventListener('theme:cart:change', event => renderRecommendations(event.detail?.cart));
  if (document.querySelector('[data-ks-cart-recommendations]')) {
    fetch(`${window.theme.routes.cart}.js`).then(response => response.json()).then(renderRecommendations).catch(() => {});
  }
})();
